import { useSession } from 'next-auth/react';

export function useCheckAdminPermissions() {
  const { data: session } = useSession();

  return session?.user?.isAdmin;
}
